import { render, staticRenderFns } from "./VacationForm.vue?vue&type=template&id=008235c0&"
import script from "./VacationForm.vue?vue&type=script&lang=js&"
export * from "./VacationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports